/* eslint-disable no-unused-vars */
import { FEATURED } from "./actionTypes";
const initialState = [];

export default function filterReducer(state = initialState, action) {
  switch (action.type) {
    case FEATURED:
      if (action.payload.featureStatus === "Featured") {
        return action.payload.books.filter((book) => book.featured === true);
      }

      return action.payload.books;

    default:
      return state;
  }
}
